__turbopack_context__.v({
  "searchIcon": "SearchIconComponent-module-scss-module___y2s_a__searchIcon",
  "searchWrapper": "SearchIconComponent-module-scss-module___y2s_a__searchWrapper",
});
